// extracted by mini-css-extract-plugin
export default {"nudgeSection":"Nudge_nudgeSection__xHrgG","header":"Nudge_header__xnXDt","nudge":"Nudge_nudge__+X95e"};